export default __webpack_public_path__ + "static/finalist seal_NSW_Best Customer Service-fd0791cd92341f889d421f2027d43adc.png";